import { type Guard, type GuardStatus, sessionAtom, useOnMount } from '@capsicum/common';
import { useAtomValue } from 'jotai';
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/navigation';
import { useCallback, useState } from 'react';

export const AnonymousGuard: Guard = () => {
	const sessionTokens = useAtomValue(sessionAtom);
	const [status, setStatus] = useState<GuardStatus>('loading');
	const { push } = useRouter();

	const onDenied = useCallback(() => push('/home'), [push]);

	useOnMount(() => setStatus(sessionTokens ? 'denied' : 'allowed'));

	return {
		onDenied,
		status: status
	};
};
